module.exports = __webpack_public_path__ + "static/images/components/Back/images/shine-to-right.efd3c166.png";


//////////////////
// WEBPACK FOOTER
// ./components/Back/images/shine-to-right.png
// module id = 2497
// module chunks = 11